module.exports = __webpack_public_path__ + "static/media/youtube_cinza.574a6fc1.svg";